import { render } from "./Material.vue?vue&type=template&id=6474d95d&scoped=true"
import script from "./Material.vue?vue&type=script&lang=js"
export * from "./Material.vue?vue&type=script&lang=js"

import "./Material.vue?vue&type=style&index=0&id=6474d95d&lang=scss&scoped=true"
import "./Material.vue?vue&type=style&index=1&id=6474d95d&lang=css"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6474d95d"]])

export default __exports__